const dbSubjectStyles = [
    { key: 'originalDashTranslated', value: 'Original - Translated' },
    { key: 'translatedDashOriginal', value: 'Translated - Original' },
    { key: 'original', value: 'Only Original' },
    { key: 'translated', value: 'Only Translated' },
];
export default dbSubjectStyles;